// extracted by mini-css-extract-plugin
module.exports = {"modal":"VO","modalContent":"WO","modalOverlay":"XO","copy":"YO","modalBtnContainer":"ZO","btnStay":"_O","disabled":"aP","btnContinue":"bP"};